/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class SidebarController {
    public static $inject = [
        '$rootScope',
        '$state',
        '$http',
        '$uibModal',
        'Api',
        'User',
        'Process',
        'Login',
        'Announcement',
        'Calendar',
        'Employee',
        'Orgs',
    ];

    public user;
    public userService;
    public visible;
    public num_requests_notifications = 0;
    private ngIScope;
    public announcesCount = 0;
    public insuranceRenewalCount = 0;
    public announcesVisited = false;
    public new_announcements = [];
    private employee;
    public not_insurance_only_client = true;
    public isHRM = false;

    constructor (private $scope: ng.IScope,
                 private $state: ng.ui.IStateService,
                 private $http: ng.IHttpService,
                 private $uibModal: any,
                 private Api: any,
                 private User: IUserService,
                 private Process: IProcessService,
                 private Login: ILoginService,
                 private Announcement: IAnnouncementService,
                 private Calendar: ICalendarService,
                 private Employee: IEmpService,
                 private Orgs: IOrgsService) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.ngIScope = $scope;
        this.visible = ($state.$current['data'] && $state.$current['data']['hideSideBar']);

        Api.one('version').get().then((response) => {
            this.ngIScope.app_version = response.version;
        });

        $scope.$on('$stateChangeStart', (e: any, toState: any) => {
            if (toState.data) {
                this.visible = !!toState.data.hideSideBar;
            }
        });

        this.user = User.getCurrentUser();

        this.userService = User;

        this.activateMenuSelected();
        // Check if this is an insurance only account
        this.not_insurance_only_client = !this.user.isInsuranceOnlyClient;
        this.isHRM = this.user.isHRM;

        // SSA does not use rest of functionality
        if (this.user.isSuperUser) {
            return;
        }

        this.Employee.loadEmployee(this.user.userData.id).then((response: Restangular.IResponse) => {
            this.employee = response;
            
            this.retrieveRequestsNotifications();


            this.Announcement.loadAnounces().then((responses) => {
                this.announcesCount += responses.length;
            });

            this.Calendar.getTodayCountEvents((_eventCounts) => {
                
                // this.announcesCount += _eventCounts;
            });


            this.Orgs.getMyOrg().then((response) => {
                const expiryStart = new Date();
                const durationEnd = 60; //In Days
                const expiryEnd = new Date();
                expiryEnd.setTime(expiryStart.getTime() +  (durationEnd * 24 * 60 * 60 * 1000));
                const getRenewals = response.extra.medical_insurance.insurance_contracts.map((ins) => {
                    const { renewal_date } = ins;
                    const renewalDate = new Date(renewal_date);
                    if ((renewalDate < expiryStart) || (expiryStart < renewalDate && renewalDate < expiryEnd)) {
                        return ins;
                    }
                    return null;
                }).filter((notNull) => notNull);
                this.insuranceRenewalCount = getRenewals.length;
            });

            this.Calendar.loadEvents(moment().startOf('day').unix(), moment().endOf('day').unix(), '', true).then((responses) => {
                let responseData: any = responses;
                if (!responseData) {
                    return;
                }

                // Check if we need to add leave items to announcement
                for (var i: number = 0; i < responseData.length; i++) {
                    if (response[i].calendar_type !== 'leaves') {
                        this.announcesCount += 1;
                    }
                    let evt: any = responseData[i];
                    let evt_id: string = 'evt_' + evt.event_id;

                    if (!this.employee.extra.announcements || this.employee.extra.announcements.indexOf(evt_id) === -1) {
                        this.new_announcements.push(evt_id);
                    }
                }
            });

            this.Employee.getWhoHaveBirthdayInMonth((responses) => {
                let responseData: any = responses.results;
                if (!responseData) {
                    return;
                }

                // Check if we need to add leave items to announcement
                for (var i: number = 0; i < responseData.length; i++) {
                    let emp: any = responseData[i];
                    let emp_id: any = emp.id;

                    if (!this.employee.extra.announcements || this.employee.extra.announcements.indexOf(emp_id) === -1) {
                        this.announcesCount += 1;
                        this.new_announcements.push(emp_id);
                    }
                }
            });

            $http.get('/api/employees/on_leave_today').then((responses) => {
                let responseData: any = responses.data;
                if (!responseData) {
                    return;
                }

                // Check if we need to add leave items to announcement
                for (var i: number = 0; i < responseData.length; i++) {
                    let emp: any = responseData[i];
                    let leave_id: any = emp.leave_today.process;

                    if (!this.employee.extra.announcements || this.employee.extra.announcements.indexOf(leave_id) === -1) {
                        this.announcesCount += 1;
                        this.new_announcements.push(leave_id);
                    }
                }
            });

            $http.get('/api/employees/expiries').then((responses) => {
                let responseData: any = responses.data;
                if (!responseData) {
                    return;
                }

                // Check if we need to add leave items to announcement
                for (var i: number = 0; i < responseData.length; i++) {
                    let emp: any = responseData[i];
                    for (var j: number = 0; j < emp.expiries.length; j++) {
                        let doc: any = emp.expiries[j];
                        let doc_id: string = 'doc_' + doc.type + doc.expiry_date + doc.number;
                        if (!this.employee.extra.announcements || this.employee.extra.announcements.indexOf(doc_id) === -1) {
                            this.new_announcements.push(doc_id);
                        }
                        this.announcesCount += 1;
                    }
                }
            });
        });

        $scope.$on('$processViewVisit', () => {
            this.num_requests_notifications = 0;
        });

        $scope.$on('$announcementsViewVisit', () => {
            this.announcesCount = 0;
            this.announcesVisited = true;
            if (this.new_announcements.length > 0) {
                this.Employee.updateAnnouncements(this.employee, this.new_announcements);
            }
        });

        $scope.$on('$incrementAnnounceCounter', () => {
            this.announcesCount += 1;
        });

        $scope.$on('$stateChangeSuccess', () => {
        });

        this.ngIScope.menuSelected = function(): void {
        };
    }

    public activateMenuSelected (): void {
        let C: this = this;

        this.ngIScope.resetTour = function(): void {
            C.Employee.setCoTourStatus(false);
        };

        this.ngIScope.menuSelected = function(): void {
        };

        this.ngIScope.releaseNotes = function(): void {
            C.ngIScope.$emit('$EL', 'release_notes');

            let modalInstance: any = C.$uibModal.open({
                templateUrl: '/static/templates/modals/release_notes_modal.html',
                controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                    // Preload navigator info
                    $scope.platformInfo = {};
                    $scope.platformInfo.appCodeName = navigator.appCodeName;
                    $scope.platformInfo.appName = navigator.appName;
                    $scope.platformInfo.appVersion = navigator.appVersion;
                    $scope.platformInfo.cookieEnabled = navigator.cookieEnabled;
                    $scope.platformInfo.language = navigator.language;
                    $scope.platformInfo.onLine = navigator.onLine;
                    $scope.platformInfo.platform = navigator.platform;
                    $scope.platformInfo.userAgent = navigator.userAgent;
                    $scope.platformInfo.cordova = !!(window['cordova'] || window['phonegap'] || window['PhoneGap']);
                    $scope.platformInfo.docURL = document.URL;

                    $scope.platformInfo.debugString = navigator.appCodeName + '|' +
                        navigator.appName + '|' +
                        navigator.appVersion + '|' +
                        navigator.cookieEnabled + '|' +
                        navigator.language + '|' +
                        navigator.onLine + '|' +
                        navigator.platform + '|' +
                        navigator.userAgent + '|' +
                        $scope.platformInfo.cordova + '|' +
                        document.URL + '|';

                    $scope.platformInfoCnt = 0;
                    $scope.modalHeader = 'Release Notes';
                    $scope.modalDetail = 'The following changes have been made to Beneple in this version:';
                    $scope.confirmButton = 'Close';
                    $scope.pageNum = 0;
                    
                    $scope.releaseNotes = [{
                        version: 'Version 3.0.0',
                        newFeatures: [],
                        improvements: ['Welcome to version 3.0. With a fresh look and clean new design, Beneple is now more useful than ever, saving you time and making your life easier!<br/><br/>We listened to your feedback and enhanced much-loved features such as requests, calendar, and tracking, whilst making the platform more user-friendly and intuitive.<br/><br/>Have a look around and explore for yourself!']
                            ,
                        bugFixes: []
                    },
                ];
                    $scope.releaseNote = $scope.releaseNotes[$scope.pageNum];               
                    $scope.confirm = () => {};
                    $scope.releaseNotesNext = () => {                          
                        $scope.pageNum ++;                       
                        if ($scope.pageNum < $scope.releaseNotes.length) {
                            $scope.releaseNote = $scope.releaseNotes[$scope.pageNum];
                        }
                    };
                    $scope.releaseNotesPrev = () => {
                        if ($scope.pageNum > 0) {                            
                            $scope.pageNum --;
                            $scope.releaseNote = $scope.releaseNotes[$scope.pageNum];
                        }
                    };
                    $scope.incPlatformInfoCnt = () => {
                        $scope.platformInfoCnt += 1;
                    };
                }]                             
            });
        };
    }

    public retrieveRequestsNotifications(): void {
        this.num_requests_notifications = 0;
        this.Process.getProcessList({'query_type': 'incoming_pending'}, 1).then((response: any) => {
            this.num_requests_notifications = response.count;
        });
    } 
}

angular.module('beneple.global')
    .controller('SidebarController', SidebarController);



// WEBPACK FOOTER //
// ./frontend/scripts/global/controllers/sidebar.controller.ts